import { render, staticRenderFns } from "./PanchoWillies_cervezasItem.vue?vue&type=template&id=2b48cd78&scoped=true"
import script from "./PanchoWillies_cervezasItem.vue?vue&type=script&lang=ts"
export * from "./PanchoWillies_cervezasItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b48cd78",
  null
  
)

export default component.exports